import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CpanelLoginPage from '../../pages/cpanel/login';
import ErrorPage from '../../pages/error';
import CpanelRoutes from './cpanel';
import HospitalRoutes from './hospital';
import { CpanelGuestGuard } from './guards/cpanelAuth';

const RoutesConfig = () => (
  <Router>
    <Routes>
      <Route element={<CpanelGuestGuard />}>
        <Route path="/" element={<CpanelLoginPage />} />
      </Route>
      <Route path="/welcome" element={<ErrorPage />} />
      <Route path="/cpanel/*" element={<CpanelRoutes />} />
      <Route path="/hospitals/:slugId/*" element={<HospitalRoutes />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default RoutesConfig;
